import React from "react";
import { Dimensions, View} from "react-native";
import {
    CreateResponsiveStyle,
    DEVICE_SIZES,
    minSize,
    maxSize,
  } from "rn-responsive-styles";

  
export default function MainContainer({children,...otherProps}){
    const styles = useStyles();
    return(
        <View style={styles.mainContainer}>{children}</View>
    )
}

const useStyles = CreateResponsiveStyle(
    // const styles = 
    {
        mainContainer : {
            backgroundColor : "#fff",
            height: '100%',
            minHeight:"100%",
            marginLeft: 20,
            marginTop:20,
            borderRadius: 12,
            width: "100%",
            
        },
    },
    {
        [DEVICE_SIZES.LG]: {
        

        },
        [DEVICE_SIZES.MD]: {
            
        },
        [DEVICE_SIZES.SM]: {
            
        },
        [DEVICE_SIZES.XS]: {
            mainContainer :{
                height:Dimensions.get("window").height,
                 minHeight:573,
                 paddingBottom:50,
                width: "100%",
                marginLeft: 10,
                backgroundColor : "#fff",   
    
            }
        }
    }
)
